@if (visible) {
  <div class="backdrop flex items-center justify-center fixed">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="48"
      strokeWidth="4"
      aria-label="Caricamento in corso"
    ></mat-progress-spinner>
  </div>
}
